import { parse, stringify } from 'querystring';

export const addParamRandom = (url = '', qs = '') => {
  const objectQs = parse(qs.replace('?', ''));
  objectQs.l = Math.floor(Math.random() * 1000);

  return `${url}?${stringify(objectQs)}`;
};
